module.exports = __webpack_public_path__ + "static/djangocon-2014-28868c9b2495eedbe970921e54c3d70a.jpg";